<template>
  <header class="header" :class="{ scrolled: isScrolled, 'menu-open': isMenuOpen }">
    <div class="container navbar">
      <router-link :to="brandLink" class="brand" @click="closeMenu">
        <img :src="brandLogo" :alt="brandTitle" class="brand-logo" />
        <span class="brand-name">{{ brandTitle }}</span>
      </router-link>

      <nav class="nav-desktop">
        <router-link to="/" class="nav-link" exact-active-class="active">Home</router-link>

        <div
          class="nav-dropdown"
          :class="{ 'is-open': productsOpen }"
          @mouseenter="openProducts"
          @mouseleave="scheduleCloseProducts"
        >
          <button
            class="nav-link nav-trigger"
            :class="{ active: isProductPage || productsOpen }"
            aria-haspopup="true"
            :aria-expanded="productsOpen"
            @click="toggleProducts"
          >
            Products
            <svg viewBox="0 0 12 12" width="10" height="10" :class="{ rotated: productsOpen }">
              <path d="M2 4.5 6 8.5 10 4.5" fill="none" stroke="currentColor" stroke-width="1.5" stroke-linecap="round"/>
            </svg>
          </button>
          <div class="dropdown" :class="{ open: productsOpen }">
            <div class="dropdown-bridge"></div>
            <div class="dropdown-body">
              <router-link
                v-for="p in products"
                :key="p.route"
                :to="p.route"
                class="dropdown-link"
                @click="closeMenu"
              >
                <img :src="p.icon" :alt="p.name" />
                <div>
                  <strong>{{ p.name }}</strong>
                  <span>{{ p.desc }}</span>
                </div>
              </router-link>
            </div>
          </div>
        </div>

        <a href="/#about" class="nav-link" @click="closeMenu">About</a>
      </nav>

      <a href="/#products" class="nav-cta btn btn-dark" @click="closeMenu">Download</a>

      <button class="menu-btn" @click="toggleMenu" :aria-expanded="isMenuOpen" aria-label="Menu">
        <span></span><span></span>
      </button>
    </div>

    <nav class="nav-mobile" :class="{ open: isMenuOpen }">
      <router-link to="/" class="mob-link" @click="closeMenu">Home</router-link>
      <p class="mob-label">Products</p>
      <router-link v-for="p in products" :key="p.route" :to="p.route" class="mob-link mob-product" @click="closeMenu">
        <img :src="p.icon" :alt="p.name" />{{ p.name }}
      </router-link>
      <a href="/#about" class="mob-link" @click="closeMenu">About</a>
    </nav>
  </header>
</template>

<script>
export default {
  name: 'Header',
  data() {
    return {
      isMenuOpen: false,
      isScrolled: false,
      productsOpen: false,
      productsCloseTimer: null,
      products: [
        { name: 'GifMaker', desc: 'Video to GIF · screen capture', route: '/product/gifmaker', icon: require('@/assets/gifmaker/logo_48x48.png') },
        { name: 'DeskClock', desc: 'Flip clock · desktop widget', route: '/product/deskclock', icon: require('@/assets/deskclock/deskclock_48x48.png') },
        { name: 'VideoCvt', desc: 'Format convert · batch', route: '/product/video-converter', icon: require('@/assets/videocvt/videovc_48x48.png') },
        { name: 'MtyZip', desc: 'ZIP / 7Z / RAR', route: '/product/compress', icon: require('@/assets/mtyzip/ziplogo48.png') },
        { name: 'EveryFile', desc: 'Instant file search', route: '/product/everyfile', icon: require('@/assets/Everyfile/everyfile_48x48.png') },
        { name: 'LongShot', desc: 'Scrolling screenshot · OCR', route: '/product/longshot', icon: require('@/assets/longshot/logo_48x48.png') },
        { name: 'FateStar', desc: 'Calendar · astrology tools', route: '/product/fatestar', icon: require('@/assets/fatestar/fatestar_48x48.png') }
      ]
    }
  },
  computed: {
    isProductPage() { return this.$route.path.startsWith('/product/') },
    brandLogo() { return require('@/assets/leaf_logo_clean.png') },
    brandTitle() {
      const m = {
        '/product/gifmaker': 'GifMaker',
        '/product/deskclock': 'DeskClock',
        '/product/everyfile': 'EveryFile',
        '/product/compress': 'MtyZip',
        '/product/video-converter': 'VideoCvt',
        '/product/longshot': 'LongShot',
        '/product/fatestar': 'FateStar'
      }
      return m[this.$route.path] || 'MTY Tools'
    },
    brandLink() {
      const m = {
        '/product/gifmaker': '/product/gifmaker',
        '/product/deskclock': '/product/deskclock',
        '/product/everyfile': '/product/everyfile',
        '/product/compress': '/product/compress',
        '/product/video-converter': '/product/video-converter',
        '/product/longshot': '/product/longshot',
        '/product/fatestar': '/product/fatestar'
      }
      return m[this.$route.path] || '/'
    }
  },
  mounted() {
    window.addEventListener('scroll', this.onScroll, { passive: true })
    document.addEventListener('click', this.onDocClick)
    this.onScroll()
  },
  beforeUnmount() {
    window.removeEventListener('scroll', this.onScroll)
    document.removeEventListener('click', this.onDocClick)
    if (this.productsCloseTimer) clearTimeout(this.productsCloseTimer)
  },
  methods: {
    onScroll() { this.isScrolled = window.scrollY > 4 },
    openProducts() {
      clearTimeout(this.productsCloseTimer)
      this.productsOpen = true
    },
    scheduleCloseProducts() {
      this.productsCloseTimer = setTimeout(() => { this.productsOpen = false }, 200)
    },
    toggleProducts(e) {
      e.stopPropagation()
      clearTimeout(this.productsCloseTimer)
      this.productsOpen = !this.productsOpen
    },
    onDocClick(e) {
      if (!this.$el.contains(e.target)) this.productsOpen = false
    },
    toggleMenu() { this.isMenuOpen = !this.isMenuOpen },
    closeMenu() {
      this.isMenuOpen = false
      this.productsOpen = false
      clearTimeout(this.productsCloseTimer)
    }
  }
}
</script>

<style scoped>
.header {
  position: fixed;
  inset: 0 0 auto;
  z-index: 1000;
  height: var(--header-h);
  background: rgba(255, 255, 255, 0.85);
  backdrop-filter: blur(12px) saturate(1.2);
  border-bottom: 1px solid transparent;
  transition: border-color var(--motion-fast), box-shadow var(--motion-fast);
}

.header.scrolled {
  border-bottom-color: var(--line);
  box-shadow: var(--shadow-sm);
}

.navbar {
  display: flex;
  align-items: center;
  height: var(--header-h);
  gap: 32px;
}

.brand {
  display: flex;
  align-items: center;
  gap: 10px;
  flex-shrink: 0;
}

.brand-logo { width: 28px; height: 28px; object-fit: contain; }

.brand-name {
  font-size: 15px;
  font-weight: 600;
  letter-spacing: -0.01em;
}

.nav-desktop {
  display: flex;
  align-items: center;
  gap: 4px;
  margin-left: auto;
}

.nav-link {
  display: inline-flex;
  align-items: center;
  gap: 4px;
  height: 36px;
  padding: 0 12px;
  font-size: 14px;
  font-weight: 500;
  color: var(--ink-muted);
  background: none;
  border: none;
  border-radius: var(--radius);
  cursor: pointer;
  font-family: inherit;
  transition: color var(--motion-fast), background var(--motion-fast);
}

.nav-link:hover,
.nav-link.active { color: var(--ink); background: var(--surface-muted); }

.nav-link svg { transition: transform var(--motion-fast); }
.nav-link svg.rotated { transform: rotate(180deg); }

.nav-dropdown { position: relative; }

.dropdown {
  position: absolute;
  top: 100%;
  left: 50%;
  transform: translateX(-50%);
  padding-top: 8px;
  opacity: 0;
  pointer-events: none;
  transition: opacity var(--motion-fast);
}

.dropdown.open { opacity: 1; pointer-events: auto; }

.dropdown-bridge {
  height: 8px;
}

.dropdown-body {
  width: 320px;
  padding: 6px;
  background: #fff;
  border: 1px solid var(--line);
  border-radius: var(--radius-lg);
  box-shadow: var(--shadow-lg);
}

.dropdown-link {
  display: flex;
  align-items: center;
  gap: 12px;
  padding: 10px 12px;
  border-radius: var(--radius);
  transition: background var(--motion-fast);
}

.dropdown-link:hover { background: var(--surface-muted); }

.dropdown-link img { width: 28px; height: 28px; object-fit: contain; flex-shrink: 0; }

.dropdown-link strong {
  display: block;
  font-size: 13px;
  font-weight: 500;
  color: var(--ink);
}

.dropdown-link span {
  font-size: 12px;
  color: var(--ink-faint);
}

.nav-cta {
  height: 36px;
  padding: 0 16px;
  font-size: 13px;
  flex-shrink: 0;
}

.menu-btn {
  display: none;
  flex-direction: column;
  justify-content: center;
  gap: 6px;
  width: 36px;
  height: 36px;
  background: none;
  border: none;
  cursor: pointer;
  margin-left: auto;
}

.menu-btn span {
  display: block;
  height: 1.5px;
  background: var(--ink);
  transition: transform var(--motion-fast), opacity var(--motion-fast);
}

.menu-open .menu-btn span:first-child { transform: translateY(3.75px) rotate(45deg); }
.menu-open .menu-btn span:last-child { transform: translateY(-3.75px) rotate(-45deg); }

.nav-mobile { display: none; }

@media (max-width: 900px) {
  .nav-desktop, .nav-cta { display: none; }
  .menu-btn { display: flex; }

  .nav-mobile {
    display: block;
    max-height: 0;
    overflow: hidden;
    background: #fff;
    border-top: 1px solid var(--line);
    transition: max-height var(--motion-base) var(--motion-ease);
  }

  .nav-mobile.open { max-height: 600px; }

  .mob-link {
    display: block;
    padding: 14px 32px;
    font-size: 15px;
    font-weight: 500;
    color: var(--ink-secondary);
    border-bottom: 1px solid var(--line);
  }

  .mob-label {
    padding: 12px 32px 6px;
    font-size: 11px;
    font-weight: 600;
    letter-spacing: 0.08em;
    text-transform: uppercase;
    color: var(--ink-faint);
  }

  .mob-product {
    display: flex;
    align-items: center;
    gap: 10px;
    padding-left: 40px;
    font-size: 14px;
  }

  .mob-product img { width: 24px; height: 24px; }
}
</style>
